import styled from 'styled-components';

import ButtonBase from '../ButtonBase';

const NavigationButton = styled(ButtonBase)`
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 24px;
  height: 24px;
  color: #fff;
  background: #888;
  border: none;
  transition: all 0.25s;

  &:disabled {
    display: none;
  }

  & svg {
    font-size: 24px;
    fill: #fff;
    transform: translateY(1px);
  }

  &:hover {
    background: ${props => props.textColor || '#888'};
    color: ${props => props.textHoverColor || '#fff'};

    & svg {
      fill: ${props => props.textHoverColor || '#fff'};
    }
  }
`;

export default NavigationButton;
